export const SET_DATA = 'SET_DATA';
export const SET_TOTAL = 'SET_TOTAL';
export const SET_PARAMS = 'SET_PARAMS';
export const SET_REQUEST = 'SET_REQUEST';
export const CLEAR_REQUESTER = 'CLEAR_REQUESTER';
export const SET_INITIAL_LOAD = 'SET_INITIAL_LOAD';
